import { asWidgetProps } from 'Src/types/widget-helpers';
import React, { ComponentProps, useContext, useRef } from 'react';
import { AFTER_APP } from 'Components/frameworks/portal/Portal.constants';
import { COLORS } from 'Components/utils/color/colors';
import { ID_LAYER_HEADER__CA__RENTALS } from 'Components/utils/identifiers/constants';
import { LAYER_NAME_UPSELL_RENTALS } from 'Components/utils/layers/layers.constants';
import { ServicesContext } from 'Context/ServicesContext';
import { TRACK_PAGE_NAMES } from 'Tracking/constants';
import { Title } from 'Components/frameworks/title/Title';
import { Toast } from 'Components/frameworks/toast/Toast';
import { ClosableLayer } from 'Components/widgets/layer/ClosableLayer';
import { BookingEngineTrackingContext } from 'Views/booking/BookingEngineTrackingContext';
import { LayerRentalsBody } from './LayerRentalsBody';
type Props = PropsWithPageTracking<{
  forwardRef?: ReactRef;
  image: string;
  layerName?: string;
  rentalsTree: RentalsTree;
  title: string;
}>;
export const LayerRentals = ({
  forwardRef,
  image,
  layerName,
  rentalsTree = [],
  title,
  tracking,
}: Props) => {
  const { updateInfo, setUpdateInfo } = useContext(ServicesContext);
  const beEngineTrackingContext = useContext(BookingEngineTrackingContext);
  const toasterRef = useRef();

  if (!rentalsTree?.length) {
    return null;
  }

  const stateTracking = tracking || {
    pageName: TRACK_PAGE_NAMES.BE_LAYER_SKI_ACTIVITIES,
    payload: { ...beEngineTrackingContext },
  };
  const header = (
    <Title
      {...asWidgetProps<ComponentProps<typeof Title>>({
        className: 'w-full justify-center',
        id: ID_LAYER_HEADER__CA__RENTALS,
        theme: 'title-brand-n4',
      })}
    >
      {title}
    </Title>
  );

  return (
    <ClosableLayer
      {...asWidgetProps<ComponentProps<typeof ClosableLayer>>({
        ariaLabel: title,
        ariaLabelledby: ID_LAYER_HEADER__CA__RENTALS,
        bgColor: COLORS.WHITE,
        externalFocusTrapRefs: [forwardRef, toasterRef],
        hasAnimateEnter: true,
        header: header,
        name: layerName || LAYER_NAME_UPSELL_RENTALS,
        params: ['id', 'catId', 'stayId'],
        tracking: stateTracking,
      })}
    >
      <Toast
        {...asWidgetProps<ComponentProps<typeof Toast>>({
          color: COLORS.SIENNA,
          isFixed: true,
          onClose: () => setUpdateInfo && setUpdateInfo(null),
          portalName: AFTER_APP,
          ref: toasterRef,
          visible: !!updateInfo,
        })}
      >
        <span className="flex items-center gap-10">
          {!!updateInfo?.itemsNumber && (
            <span className="inline-flex size-30 shrink-0 items-center justify-center rounded-full bg-success p-5 text-white">
              +{updateInfo.itemsNumber}
            </span>
          )}
          {updateInfo?.message}
        </span>
      </Toast>
      <LayerRentalsBody
        {...asWidgetProps<ComponentProps<typeof LayerRentalsBody>>({
          image: image,
          rentalsTree: rentalsTree,
        })}
      />
    </ClosableLayer>
  );
};
